export default __webpack_public_path__ + "static/media/icons-left.776fd855.png";